export class RetrieveEmail{
    pkcolab:string;
}